module.exports = __webpack_public_path__ + "img/grrz.581d0810.png";